export default{
  BP: 768,
  DIR: '/',
}